import API from "./GlobalAPI";

interface UserInfoProp {
  full_name: string;
  user_info: {
    phone_number: string;
    address: string;
  };
}

export async function getUserById(id: string) {
  try {
    const res: any = await API.getMethod(`users/${id}`);

    return res.data;
  } catch (err) {
    console.log(err);
  }
}

export async function updateUserById(id: string, data: UserInfoProp) {
  try {
    const res: any = await API.putMethod(`users/${id}`, data);

    return res.data;
  } catch (err) {
    console.log(err);
  }
}
